/**
 * Gets an image which represents a preview image for a youtube video
 * @param videoId The id for the youtube video to get a preview image
 */
export default function getYoutubeVideoThumb(videoId: string) {
  return `https://img.youtube.com/vi/${videoId}/default.jpg`;
}
